export class Needs {
  completed = false;
  questionNeedAssessments = []
}



// WEBPACK FOOTER //
// ./src/app/core/models/needs.ts